<template>
  <span class="burger-icon">
    <span></span>
  </span>
</template>

<script>
export default {
  name: 'BurgerIcon'
}
</script>

<style lang="scss" scoped>
.burger-icon {
  position: relative;
  height: 10px;
  width: 14px;

  span {
    background-color: #4f4f4f;
    border-radius: 5px;
    display: block;
    height: 2px;
    left: 0px;
    position: absolute;
    top: 4px;
    width: 14px;

    &:before {
      background-color: inherit;
      border-radius: inherit;
      content: '';
      height: inherit;
      left: inherit;
      margin-top: -4px;
      position: inherit;
      width: inherit;
    }

    &:after {
      background-color: inherit;
      border-radius: inherit;
      content: '';
      height: inherit;
      left: inherit;
      margin-top: 4px;
      position: inherit;
      width: inherit;
    }
  }
}
</style>
